import React from "react";

import { Alert, Button } from "../../../components/ui";

import { MODE_CLOSED, MODE_OPEN, MODE_DONE } from "./constants";
import AddProductPriceForm from "./AddProductPriceForm";

const AddProductPriceView = ({
  productId,
  mode,
  product,
  onAddPrice,
  onCancel,
  onDone,
}) => {
  switch (mode) {
    case MODE_CLOSED:
      return (
        <div className="">
          <Button variant="secondary" data-btn="price-add" onClick={onAddPrice}>
            Add price
          </Button>
        </div>
      );
    case MODE_OPEN:
      return (
        <AddProductPriceForm
          {...{
            productId,
            item: product,
            onDone,
            onCancel,
          }}
        />
      );
    case MODE_DONE:
      return (
        <Alert tone="success" title="Price added" onDismiss={onCancel} />
      );
    default:
      return null;
  }
};

export default AddProductPriceView;
